import { templatesModel } from '../../../features/templates';
import { pageCreationFlowModel } from '../../../processes/page-creation-flow';
import { useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { TemplateExtended } from '@distribute/shared/api-types/templates';

export const usePreviewTemplate = () => {
  const dispatch = useDispatch();

  const handleTemplatePreview = useCallback(
    (template: TemplateExtended) => {
      dispatch(templatesModel.actions.setCurrentSelectedTemplate(template));
      dispatch(templatesModel.actions.setPreviewMode(true));
      dispatch(
        pageCreationFlowModel.actions.openPageCreationFlow({ mode: 'template' })
      );
    },
    [dispatch]
  );

  return { handleTemplatePreview };
};
